<template>
  <PullToRefresh
    :onRefresh="handlePullToRefresh"
    :pullText="$t('common.pull_to_refresh')"
    :releaseText="$t('common.release_to_refresh')"
    :refreshingText="$t('common.refreshing')"
  >
    <div class="quotes-page">
      <div class="container container--fluid">
        <PageHeader
          :title="$t('quotes.title')"
          :description="$t('quotes.description')"
        ></PageHeader>

        <div class="quotes-page__content">
          <ProposalsView :proposals="proposals" />
        </div>
      </div>
    </div>
  </PullToRefresh>
</template>

<script>
  import { ref, computed, onMounted } from 'vue';
  import { useCrmStore } from '@/store/crmStore';
  import { useI18n } from '@/composables/useI18n';
  import PageHeader from '@/components/partials/PageHeader.vue';
  import ProposalsView from '@/components/crm/ProposalsView.vue';
  import PullToRefresh from '@/components/partials/PullToRefresh.vue';
  import Btn from '@/components/partials/Btn.vue';

  export default {
    name: 'QuotesPage',
    components: {
      PageHeader,
      ProposalsView,
      PullToRefresh,
      Btn,
    },
    setup() {
      const { t } = useI18n();
      const crmStore = useCrmStore();

      const loading = computed(() => crmStore.loading);
      const proposals = computed(() => crmStore.proposals);
      const proposalPagination = computed(() => crmStore.proposalPagination);

      const handlePullToRefresh = async () => {
        await crmStore.fetchProposals({
          page: 1,
          limit: 50,
        });
      };

      onMounted(() => {
        crmStore.fetchProposals({
          page: 1,
          limit: 50,
        });
      });

      return {
        loading,
        proposals,
        proposalPagination,
        handlePullToRefresh,
        $t: t,
      };
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/scss/base/_mixins.scss';

  .quotes-page {
    //
  }
</style>
